"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _CategoryPage = require("./CategoryPage");
Object.keys(_CategoryPage).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CategoryPage[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _CategoryPage[key];
        }
    });
});
var _CategoryPageSkeleton = require("./CategoryPageSkeleton");
Object.keys(_CategoryPageSkeleton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _CategoryPageSkeleton[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _CategoryPageSkeleton[key];
        }
    });
});
var _LandingPage = require("./LandingPage");
Object.keys(_LandingPage).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _LandingPage[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _LandingPage[key];
        }
    });
});
var _LandingPageSkeleton = require("./LandingPageSkeleton");
Object.keys(_LandingPageSkeleton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _LandingPageSkeleton[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _LandingPageSkeleton[key];
        }
    });
});
